export default "__VITE_ASSET__DmYwgfR1__"